import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';
export const convertDate = (data) => {
  if (!data) return '-';
  const parsedDate = parseISO(data);
  const formattedDate = format(parsedDate, 'MMM dd . yyyy , hh:mm a');

  return formattedDate;
};
